module.exports = __webpack_public_path__ + "static/media/Apple iPhone 7 Rose Gold.f061c300.png";